export default __webpack_public_path__ + "static/media/Aula2.e81bfe70.jpeg";